const store = {
    isReady: false,
    dispatch: () => {
        console.error('store is NOT ready')
    },
    state: null,
}

export default store
